import React from 'react'
import StudentButton from './StudentButton'
import useOpenStudent from './useOpenStudent'

function SingleRowStudent({ students }) {
    const openStudent = useOpenStudent()
    const studentInfo1 = students[0]
    const studentInfo2 = students.length == 2 ? students[1] : null
    return (
        <div className="flex flex-col gap-[80px] " style={{ justifyContent: !!studentInfo2 ? 'flex-start' : 'center' }}>
            <StudentButton
                animal={studentInfo1?.user?.animal ?? 'tiger'}
                key={studentInfo1?.user?.id}
                student={studentInfo1?.user}
                emotion={studentInfo1?.feedback?.emotion ?? 'ok'}
                style={{ marginLeft: 20 }}
                onClick={openStudent}
            />
            {!!studentInfo2 && (
                <StudentButton
                    animal={studentInfo2?.user?.animal ?? 'tiger'}
                    key={studentInfo2?.user?.id}
                    student={studentInfo2?.user}
                    emotion={studentInfo2?.feedback?.emotion ?? 'ok'}
                    style={{ marginLeft: -20 }}
                    onClick={openStudent}
                />
            )}
        </div>
    )
}

export default SingleRowStudent
